import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-modal-market-create-store-success',
  templateUrl: './modal-market-create-store-success.component.html',
  styleUrls: ['./modal-market-create-store-success.component.scss']
})
export class ModalMarketCreateStoreSuccessComponent implements OnInit {

  @ViewChild('createStoreSuccessModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };

  message = '';
  callback: Function;
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.modalServ.onMarketCreateStoreSuccess.subscribe(req => {
      this.callback = req.callback;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onMarketCreateStoreSuccessHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }

  confirm() {
    this.hide();
    this.callback();
  }

  close() {
    this.hide();
  }

}
